// Placeholder identities never represent a followable speaker or show.
export const hasKnownEntityId = id => typeof id === 'string'
    && id.trim().length > 0 && id.trim().toLowerCase() !== 'unknown';

// Catalog results can be followed before saving resolves their canonical source.
// A resolved source takes precedence; aliases never override an invalid source ID.
export const hasKnownShowIdentity = (show, resolvedSource = show?.source) => {
    const sourceId = resolvedSource?.id ?? show?.id;
    if (sourceId != null) return hasKnownEntityId(sourceId);
    const appleId = typeof show?.appleCollectionId === 'number' && Number.isFinite(show.appleCollectionId)
        ? String(show.appleCollectionId) : show?.appleCollectionId;
    return [show?.key, show?.rssURL, appleId].some(hasKnownEntityId);
};
